import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type PostLoginService from 'tio-employee/services/post-login';
import type PreRegisterService from 'tio-employee/services/pre-register';

export default class PostLoginTermsRoute extends Route {
  @service declare postLogin: PostLoginService;
  @service declare preRegister: PreRegisterService;
  @service declare router: RouterService;

  async beforeModel() {
    this.postLogin.initializeFromSession();
    if (!this.postLogin.tempToken) {
      this.router.transitionTo('login');
      return;
    }
    await this.preRegister.loadTermsAndConditions();
  }
}
